import { useContext, useState } from 'react';
import './WorkOrderDetails.css';
import { useQuery } from '@tanstack/react-query';
import { ClipLoader } from 'react-spinners';
import { formatInTimeZone } from 'date-fns-tz';
import { AppInfoContext, UserContext } from '../../../../../../App';
import Department from './selectoptions/Department';

export default function WorkOrderDetails({ setFormStep }) {
  const { appInformation, setAppInformation } = useContext(AppInfoContext);
  const { userDetails } = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(true);
  const token = localStorage.getItem('token');

  const canAccess = [0, 8].includes(userDetails.role);

  const apiUrl = process.env.REACT_APP_BACKEND_API;

  const fetchWorkOrderDetails = async () => {
    const response = await fetch(
      `${apiUrl}/work-orders/${appInformation.problemManagement.id}/problem`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.json();
  };

  const { data } = useQuery(['workOrderDetails'], fetchWorkOrderDetails, {
    onSuccess: (response) => {
      setAppInformation((prevValue) => ({
        ...prevValue,
        problemManagement: {
          ...prevValue.problemManagement,
          workOrderId: response.id,
          workOrderSerialNumber: response.serialNumber,
        },
      }));
      setIsLoading(false);
    },
    onError: (error) => {
      setIsLoading(false);
    },
  });

  const getLabelByValue = (value, enumType) => {
    const field = Object.values(enumType).find((type) => type.value === value);
    return field ? field.label : 'Unknown';
  };

  const deleteWorkOrderModal = () => {
    setAppInformation((prevValue) => ({
      ...prevValue,
      problemManagement: {
        ...prevValue.problemManagement,
        workOrderId: data.id,
        workOrderSerialNumber: data.serialNumber,
      },
    }));
    setFormStep(4);
  };
  return (
    <>
      {isLoading && (
        <div className="wo-details-spinner">
          <ClipLoader
            color={'gray'}
            loading={isLoading}
            size={60}
            data-testid="loader"
          />
        </div>
      )}

      {!isLoading && (
        <div>
          <div
            className="wo-details-form-body"
            style={{
              height: appInformation.statistics.problemModalActive && '548px',
            }}
          >
            <div>
              <div>
                <label htmlFor="serialNumber" className="wo-details-label">
                  Broj radnog naloga
                </label>
                <input
                  disabled
                  type="text"
                  id="serialNumber"
                  value={data.serialNumber}
                  name="serialNumber"
                  className="wo-details-field"
                />
              </div>
              <div className="wo-details-date">
                <div>
                  <label htmlFor="createdDate" className="wo-details-label">
                    Datum unosa
                  </label>
                  <input
                    type="text"
                    id="createdDate"
                    name="createdDate"
                    className="wo-details-date-field"
                    value={formatInTimeZone(
                      data.createdAt,
                      'Europe/Paris',
                      'dd.MM.yyyy.'
                    )}
                    disabled
                  />
                </div>
                <div>
                  <label htmlFor="createdTime" className="wo-details-label">
                    Vrijeme unosa
                  </label>
                  <input
                    type="text"
                    id="createdTime"
                    name="createdTime"
                    className="wo-details-date-field"
                    value={formatInTimeZone(
                      data.createdAt,
                      'Europe/Paris',
                      'HH:mm'
                    )}
                    disabled
                  />
                </div>
              </div>

              <div>
                <label htmlFor="department" className="wo-details-label">
                  Služba izvršenja
                </label>
                <input
                  disabled
                  type="text"
                  id="department"
                  value={getLabelByValue(data.executionDepartment, Department)}
                  name="department"
                  className="wo-details-field"
                />
              </div>

              <label htmlFor="startDate" className="wo-details-label">
                Planirani period početka radova
              </label>
              <div className="wo-details-date">
                <div>
                  <input
                    type="text"
                    id="startDate"
                    name="startDate"
                    className="wo-details-date-field"
                    value={formatInTimeZone(
                      data.startDate,
                      'Europe/Paris',
                      'dd.MM.yyyy.'
                    )}
                    disabled
                  />
                </div>
                <div>
                  <input
                    type="text"
                    id="startTime"
                    name="startTime"
                    className="wo-details-date-field"
                    value={formatInTimeZone(
                      data.startDate,
                      'Europe/Paris',
                      'HH:mm'
                    )}
                    disabled
                  />
                </div>
              </div>
              <label htmlFor="endDate" className="wo-details-label">
                Planirani period završetka radova
              </label>
              <div className="wo-details-date">
                <div>
                  <input
                    type="text"
                    id="endDate"
                    name="endDate"
                    className="wo-details-date-field  wo-details-last-field"
                    value={formatInTimeZone(
                      data.endDate,
                      'Europe/Paris',
                      'dd.MM.yyyy.'
                    )}
                    disabled
                  />
                </div>
                <div>
                  <input
                    type="text"
                    id="endTime"
                    name="endTime"
                    className="wo-details-date-field  wo-details-last-field"
                    value={formatInTimeZone(
                      data.endDate,
                      'Europe/Paris',
                      'HH:mm'
                    )}
                    disabled
                  />
                </div>
              </div>
            </div>

            <div>
              <div>
                <label htmlFor="note" className="wo-details-label">
                  Napomena
                </label>
                <textarea
                  disabled
                  id="note"
                  value={data.note}
                  name="note"
                  className="wo-details-field wo-details-textarea"
                />
              </div>
              <div>
                <label htmlFor="description" className="wo-details-label">
                  Opis kvara
                </label>
                <textarea
                  disabled
                  id="description"
                  value={data.description}
                  name="description"
                  maxLength="180"
                  className="wo-details-field wo-details-textarea"
                  style={{ height: canAccess ? '121px' : '175px' }}
                />
              </div>

              <div className="work-order-buttons">
                {!appInformation.statistics.problemModalActive &&
                  [0, 8].includes(userDetails.role) && (
                    <button
                      className="close-work-order-button"
                      onClick={() => setFormStep(5)}
                    >
                      Zatvori radni nalog
                    </button>
                  )}

                {!appInformation.statistics.problemModalActive &&
                  [0, 8].includes(userDetails.role) && (
                    <button
                      className="delete-work-order-button"
                      onClick={deleteWorkOrderModal}
                    >
                      Poništi radni nalog
                    </button>
                  )}

                {![0, 8].includes(userDetails.role) && (
                  <div
                    className="wo-status-info "
                    style={{
                      borderColor: '#FFDE21',
                      color: '#FFDE21',
                    }}
                  >
                    Radni nalog u obradi
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="work-order-buttons-desktop">
            {!appInformation.statistics.problemModalActive &&
              [0, 8].includes(userDetails.role) && (
                <button
                  className="close-work-order-button"
                  onClick={() => setFormStep(5)}
                >
                  Zatvori radni nalog
                </button>
              )}

            {!appInformation.statistics.problemModalActive &&
              [0, 8].includes(userDetails.role) && (
                <button
                  className="delete-work-order-button"
                  onClick={deleteWorkOrderModal}
                >
                  Poništi radni nalog
                </button>
              )}

            {![0, 8].includes(userDetails.role) && (
              <div
                className="wo-status-info "
                style={{
                  borderColor: '#FFDE21',
                  color: '#FFDE21',
                }}
              >
                Radni nalog u obradi
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
